import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Grid,
  Typography,
  IconButton,
  TextField,
  Stack,
  Badge,
} from "@mui/material";
import ProfImg from "../assets/images/testominalSmith.png";
import CustomSnackbar from "../components/shared/snackbar";
import Iconify from "../components/iconify";
import axios from "axios";
import { useResponsive } from "../hooks/use-responsive";

function DashProfile() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const UPLOAD_PROFILE_PIC = `${SERVER_URI}/uploadProfilePicture/`;
  const GET_USER = `${SERVER_URI}/user`;

  const mdUp = useResponsive("up", "md");
  const [userId, setUserId] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [LastName, setLastName] = React.useState("");
  const [userName, setUserName] = React.useState("");
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [variant, setMessageVariant] = React.useState("");
  const [selectedImage, setSelectedImage] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [spinner, setSpinner] = React.useState(true);
  const [openexpireDialog, setOpenexpireDialog] = React.useState(false);
  const [res, setRes] = React.useState([]);

  const fileInputRef = React.useRef(null);
  const handleEditClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input click
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    if (res.length === 0) {
      axios
        .get(
          GET_USER,
          config,
            {
            withCredentials: true,
            // ...config, // add config to include authorization header
          }
        )
        .then((response) => {
          setSpinner(false);
          setRes(response.data.user);
         
          const user = response.data.user;
          setUserId(user._id);
          setEmail(user.email);
          setFirstName(user.name);
          setLastName(user.lastName);
          setUserName(user.username);
          setMobileNumber(user.mobileNumber)
          if (user.profilePictureUrl && user.profilePictureUrl !== "") {
            setSelectedImage(user.profilePictureUrl);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            // Token is expired or invalid, open the dialog
            setOpenexpireDialog(true);
          }
        });
    }
  }, []);

  const uploadProfilePicture = async (file) => {
    const formData = new FormData();
    formData.append("profilePicture", file);

    try {
      let token = localStorage.getItem("accessToken");
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const res = await axios.post(
        UPLOAD_PROFILE_PIC + userId,
        formData,
        config,
          {
          withCredentials: true,
        }
      );
      setSnackbarOpen(true);
      if (res.data.message) {
        setMessage(res.data.message);
        setMessageVariant("success");
        // Save the uploaded image URL to local storage
        // localStorage.setItem('profileImageURL', res.data.imageUrl);
        setSelectedImage(res.data.imageUrl);
        setSpinner(false);
      } else if (res.data.warning) {
        setMessage(res.data.warning);
        setMessageVariant("warning");
      } else if (res.data.error) {
        setMessage(res.data.error);
        setMessageVariant("error");
      }
      setTimeout(() => {
        setSnackbarOpen(false);
      }, 5000);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400 || err.response.status === 401 ) {
        setMessage(err.response.data.error);
        setMessageVariant("error");
        setSnackbarOpen(true);
        setOpenexpireDialog(true);
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.includes("image")) {
      uploadProfilePicture(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  return (
    <>
      <Box sx={{ p: 3, mb: 5, backgroundColor: "#F1F1F1", borderRadius: 5 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Sofia Sans Extra Condensed",
            fontWeight: 700,
            color: "#1E53E8",
            textTransform: "uppercase",
            textAlign:{sm:'center',xs:'center',md:'justify'}
          }}
        >
          Profile Information
        </Typography>
        <Box mt={3} mb={5}>
          <Box
            display="flex"
            justifyContent="center"
            mb={3}
            position="relative"
          >
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              badgeContent={
                <IconButton
                  onClick={handleEditClick}
                  color="primary"
                  sx={{
                    backgroundColor: "#1D53E7",
                    color: "white",
                    border: "1px solid #1565C0",
                    width: 35,
                    height: 35,
                    "&:hover": {
                      backgroundColor: "#FFECEC",
                      transform: "scale(1.05)",
                      color: "#F03D55",
                      fontWeight: 600,
                    },
                  }}
                >
                  <Iconify icon="mdi:edit-outline" />
                </IconButton>
              }
            >
              <Avatar
                alt="Travis Howard"
                src={selectedImage}
                sx={{ width: "113px", height: "113px" }}
              />
            </Badge>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
            />
          </Box>

          <Stack justifyContent="center" alignItems="center">
            <Grid container spacing={4} lg={8}>
              {/* Email */}
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 550, color: "#1F1F1F" }}
                >
                  Email
                </Typography>
                <TextField
                  fullWidth
                  value={email}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#1D53E7", fontWeight: "700" },
                  }}
                  variant="outlined"
                  size="medium"
                />
              </Grid>

              {/* First Name and Last Name */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 550, color: "#1F1F1F" }}
                >
                  First Name
                </Typography>
                <TextField
                  fullWidth
                  value={firstName}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#1D53E7", fontWeight: "700" },
                  }}
                  variant="outlined"
                  size="medium"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 550, color: "#1F1F1F" }}
                >
                  Last Name
                </Typography>
                <TextField
                  fullWidth
                  value={LastName}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#1D53E7", fontWeight: "700" },
                  }}
                  variant="outlined"
                  size="medium"
                />
              </Grid>

              {/* Phone Number and Birth Date */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 550, color: "#1F1F1F" }}
                >
                  Phone Number
                </Typography>
                <TextField
                  fullWidth
                  value={mobileNumber}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#1D53E7", fontWeight: "700" },
                  }}
                  variant="outlined"
                  size="medium"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 550, color: "#1F1F1F" }}
                >
                  {/* Birth Date */}
                  UserName
                </Typography>
                <TextField
                  fullWidth
                  value={userName}
                  InputProps={{
                    readOnly: true,
                    sx: { color: "#1D53E7", fontWeight: "700" },
                  }}
                  variant="outlined"
                  size="medium"
                />
              </Grid>
            </Grid>
          </Stack>
        </Box>
        <CustomSnackbar
          message={message}
          variant={variant}
          open={snackbaropen}
        />
      </Box>
    </>
  );
}

export default DashProfile;
